import { render } from "./MediaTabs.vue?vue&type=template&id=28e4a87e&scoped=true"
import script from "./MediaTabs.vue?vue&type=script&lang=js"
export * from "./MediaTabs.vue?vue&type=script&lang=js"

import "./MediaTabs.vue?vue&type=style&index=0&id=28e4a87e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e4a87e"]])

export default __exports__